import React from "react";
import BaseComponent from "../BaseComponent";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";
import NanoFlex from "../Global/NanoFlex.js";
import searchService from "../../services/SearchService.js";

import Button from "../Nano/Buttons/Button.js";
import Type from "../Global/Typography.js";
import Input from "../Nano/Input.js";

import { ReactComponent as SavedSearch } from "../Global/Icons/savedSearch.svg";

const multiple = nota.global.multiple;

const EditSavedSearchModalStyle = styled.div`
  width: 350px;
  background-color: ${nota.color.neutral.white};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  padding: ${multiple * 3 + "px"};
  .headerModal {
    padding-bottom: ${multiple + "px"};
    border-bottom: 0.5px solid ${nota.color.neutral.NeuFour};
    svg {
      height: 16px;
      width: 16px;
      path {
        fill: ${nota.color.main.default};
      }
    }
    h3 {
      margin-left: ${multiple + "px"};
      text-transform: uppercase;
      b {
        color: ${nota.color.main.default};
      }
    }
  }
  .modalContainer {
    .modalWrapper {
      padding: ${multiple * 3 + "px"} 0;
    }
  }

  .formWrapper {
    margin-bottom: ${multiple + "px"};
    .formContainer {
      margin-bottom: ${multiple + "px"};
    }
    p {
      margin-bottom: 2px;
    }
    .dropDownContainer {
      width: 100%;
    }
    .inputWrapper {
      width: 100%;
      div {
        margin: 0;
      }
    }
    textarea {
      font-family: ${nota.font};
      width: 100%;
      height: 150px;
      overflow: auto;
      border: 1px solid ${(props) => (props.error ? nota.color.main.mTwo : nota.color.neutral.NeuTwo)};
      padding: 10px;
      width: 100%;
      font-size: 12px;
      color: ${nota.color.neutral.NeuOne};
      resize: none;
      &::placeholder {
        color: ${nota.color.neutral.NeuTwo};
      }
    }
  }

  .btnsContainer {
    padding: 16px 8px 0 8px;
    border-top: 0.5px solid ${nota.color.neutral.NeuFour};
    .cta {
      margin: 0;
    }
  }

  .dropDownWrapper {
    .dropdown-content {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
    }
  }
  /* MEDIA QUERIES */
  @media only screen and (max-width: 520px) {
    width: 90vw;
    margin: auto;
    .btnsContainer {
      flex-direction: column;
      .buttonWrapper {
        order: 1;
      }
      .simpleButtonWrapper {
        order: 2;
        margin-top: ${multiple + "px"};
      }
    }
  }
`;

class EditSavedSearchModal extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = this.getDefaultState();
  }

  getDefaultState = () => {
    return {
      savedSearch: this.props.savedSearch,
      NameError: false,
    };
  };

  componentDidUpdate(prevProps, prevState) {}

  onNameChange = (value) => {
    let immutableObj = { ...this.state.savedSearch };
    immutableObj.searchName = value;
    this.setState({ savedSearch: immutableObj });
  };

  onDescriptionChange = (value) => {
    let immutableObj = { ...this.state.savedSearch };
    immutableObj.description = value;
    this.setState({ savedSearch: immutableObj });
  };

  saveSearch = () => {
    if (this.state.savedSearch.searchName && this.state.savedSearch.searchName.trim() != "") {
      this.setState({ NameError: false });
      searchService
        .saveSearch(this.state.savedSearch)
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            // Catch
            if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
          }
        })
        .then((data) => {
          /*Trigger playlistsChange Event */
          window.dispatchEvent(new Event("playlistsChange"));
          if (this.props.nextAction) this.props.nextAction();
        });
    } else {
      this.setState({ NameError: true });
    }
  };

  cancelSaveSearch = () => {
    if (this.props.cancelAction) this.props.cancelAction();
  };

  render() {
    return (
      <EditSavedSearchModalStyle>
        <NanoFlex className="headerModal" justifyContent="flex-start">
          <SavedSearch />
          <Type.h3>
            <b>{this.translation.savedSearch.editSavedSearch}</b>
          </Type.h3>
        </NanoFlex>
        <NanoFlex className="modalContainer" flexDirection={"column"} justifyContent="space-between" alignContent="space-between">
          <NanoFlex className="modalWrapper" flexDirection={"column"}>
            <NanoFlex className="formWrapper" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
              <NanoFlex className="formContainer" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
                <Type.p>{this.translation.savedSearch.name}</Type.p>
                <div className="inputWrapper">
                  <Input defaultValue={this.state.savedSearch.searchName} title="" placeholder={this.translation.savedSearch.namePlaceholder} error={this.state.NameError} onChangeAction={this.onNameChange} />
                </div>
              </NanoFlex>

              <NanoFlex className="formContainer" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
                <Type.p>{this.translation.savedSearch.description}</Type.p>
                <textarea
                  value={this.state.savedSearch.description}
                  placeholder={this.translation.savedSearch.descriptionPlaceholder}
                  onChange={(e) => {
                    this.onDescriptionChange(e.target.value);
                  }}></textarea>
              </NanoFlex>
            </NanoFlex>
          </NanoFlex>

          <NanoFlex className="btnsContainer" alignContent={"flex-end"}>
            <Button label={this.translation.geral.cancel} simple clickAction={this.cancelSaveSearch} />
            <Button label={this.translation.geral.confirm} clickAction={this.saveSearch} />
          </NanoFlex>
        </NanoFlex>
      </EditSavedSearchModalStyle>
    );
  }
}

// Set default props
EditSavedSearchModal.defaultProps = {
  cancelAction: () => null,
  nextAction: () => null,
};

export default EditSavedSearchModal;

/*
Doc
import EditSavedSearchModal from '../../Micro/EditSavedSearchModal.js';

<EditSavedSearchModal
    cancelAction={() => console.log('cancelAction')}
    nextAction={() => console.log('nextAction')}
/>
*/
